// src/api/useFetchObjects.js
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_URL } from "../config";

const useFetchObjects = (queryKey, endpoint, token, options = {}) => {
  const fetchFunction = async () => {
    const headers = token ? { Authorization: `Token ${token}` } : {};
    const response = await axios.get(
      `${API_URL}/${endpoint}`,
      {
        headers,
      },
    );
    return response.data;
  };

  const { data, isLoading, isError, isSuccess, error, refetch } = useQuery({
    queryKey: queryKey,
    queryFn: fetchFunction,
    enabled: Boolean(token),
    ...options,
  });

  return { data, isLoading, isError, isSuccess, error, refetch };
};

export default useFetchObjects;
